import React, { useState, useEffect } from 'react';

function SearchFilter(props) {
  // Declare a new state variable, which we'll call "count"
  const [expand, setExpand] = useState(expand || false);
  useEffect(() => {}, [expand]);
  let fOpts=[];
  if(props.filter) {
    fOpts = props.filter.map((val)=> {
      let active = props.activeFilter.includes(val.name)
      return(<label title={val.alias} key={val.name} className="checkbox-inline" style={{marginLeft:'12px'}}>
        <input
          data-filtername={val.name}
          type="checkbox"
          checked={ active }
          value={ val.name }
          onChange={ props.toggleFilter }
        />
        <i className={val.icon}></i>
      </label>)
    })
  }
  return (
    
    <span style={{position:'relative',fontSize: '22px', display:'flex'}}>
      <i className={`mdi mdi-filter${(expand ? '' :'-outline')}`} style={{cursor:'pointer'}} onClick={() => setExpand(!expand)} />
      {expand && <div style={{display:'flex', position:'relative', fontSize:'16px', alignItems: 'center'}}>{fOpts} 
        </div>}
    </span>
  );
}

export default SearchFilter;